import { useLocalStorage } from "@vueuse/core";

export default {
  state: {
    isFiltered: false,
    currentFloor: "1",
    settings: {
      city: { id: "", name: "Город" },
      building: { id: "", city: "", name: "Здание", floorsList: [] },
      equipment: []
    },
    settingsBO: {
      city: { id: "", name: "Город" },
      building: { id: "", city: "", name: "Здание", floorsList: [] },
      room: { id: "", name: "Переговорная" },
      equipment: [],
      type: { id: "", name: "Вид бронирования" }
    },
    get settingsBORoom() {
      return useLocalStorage("settingsBORoom", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] },
        room: { id: "", name: "Переговорная" }
      }).value;
    },
    get settingsBOCoworking() {
      return useLocalStorage("settingsBOCoworking", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      }).value;
    },
    get settingsBOLocker() {
      return useLocalStorage("settingsBOLocker", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      }).value;
    },
    get settingsBOPass() {
      return useLocalStorage("settingsBOPass", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      }).value;
    },
    get settingsBOAccess() {
      return useLocalStorage("settingsBOAccess", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      }).value;
    },
    cities: [],
    buildings: []
  },
  getters: {
    getCurrentFloor: (s: any) => s.currentFloor,
    selectedBuilding(state) {
      return `${state.settings.city.name}, ${
        state.settings.building.name ? state.settings.building.name : "Здание"
      }`;
    },
    filteredCityBuildings(state) {
      return state.buildings.filter((b) => b.city === state.settings.city.id);
    },
    cities: (s: any) => s.cities,
    settings: (s: any) => s.settings,
    settingsBO: (s: any) => s.settingsBO,
    settingsBORoom: (s: any) => s.settingsBORoom,
    settingsBOCoworking: (s: any) => s.settingsBOCoworking,
    settingsBOLocker: (s: any) => s.settingsBOLocker,
    settingsBOPass: (s: any) => s.settingsBOPass,
    settingsBOAccess: (s: any) => s.settingsBOAccess,
    floors: (s: any) => s.settings.building.floorsList,
    isFiltered: (s: any) => s.isFiltered
  },
  mutations: {
    setCurrentFloor(state, payload: string) {
      state.currentFloor = payload;
    },
    setFilterActive(state, payload) {
      state.isFiltered = payload;
    },
    setFilterCity(state, payload) {
      state.settings = { ...state.settings, city: payload };
    },
    setFilterBuilding(state, payload) {
      state.settings.building = payload;
    },
    setFilterCityBO(state, payload) {
      state.settingsBO = { ...state.settingsBO, city: payload };
    },
    setFilterBuildingBO(state, payload) {
      state.settingsBO.building = payload;
    },
    setFilterTypeBO(state, payload) {
      state.settingsBO.type = payload;
    },
    setFilterRoomBO(state, payload) {
      state.settingsBO.room = payload;
    },
    setFilterEquipment(state, payload) {
      state.settings = { ...state.settings, equipment: payload };
    },
    setFilterBORoomRoom(state, payload) {
      const storage = useLocalStorage("settingsBORoom", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] },
        room: { id: "", name: "Переговорная" }
      });
      storage.value.room = payload;
    },
    setFilterBORoomCity(state, payload) {
      console.log("setFilterBORoomCity", payload);
      const storage = useLocalStorage("settingsBORoom", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] },
        room: { id: "", name: "Переговорная" }
      });
      storage.value.city = payload;
    },
    setFilterBORoomBuilding(state, payload) {
      const storage = useLocalStorage("settingsBORoom", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] },
        room: { id: "", name: "Переговорная" }
      });
      storage.value.building = payload;
    },
    setFilterBOPassCity(state, payload) {
      const storage = useLocalStorage("settingsBOPass", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      });
      storage.value.city = payload;
    },
    setFilterBOPassBuilding(state, payload) {
      const storage = useLocalStorage("settingsBOPass", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      });
      storage.value.building = payload;
    },
    setFilterBOAccessCity(state, payload) {
      const storage = useLocalStorage("settingsBOAccess", {
        city: { id: undefined, name: "Город" },
        building: {
          id: undefined,
          city: undefined,
          name: "Здание",
          floorsList: []
        }
      });
      storage.value.city = payload;
    },
    setFilterBOAccessBuilding(state, payload) {
      const storage = useLocalStorage("settingsBOAccess", {
        city: { id: undefined, name: "Город" },
        building: {
          id: undefined,
          city: undefined,
          name: "Здание",
          floorsList: []
        }
      });
      storage.value.building = payload;
    },
    setFilterBOLockerCity(state, payload) {
      const storage = useLocalStorage("settingsBOLocker", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      });
      storage.value.city = payload;
    },
    setFilterBOLockerBuilding(state, payload) {
      const storage = useLocalStorage("settingsBOLocker", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      });
      storage.value.building = payload;
    },
    setFilterBOCoworkingCity(state, payload) {
      const storage = useLocalStorage("settingsBOCoworking", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      });
      storage.value.city = payload;
    },
    setFilterBOCoworkingBuilding(state, payload) {
      const storage = useLocalStorage("settingsBOCoworking", {
        city: { id: "", name: "Город" },
        building: { id: "", city: "", name: "Здание", floorsList: [] }
      });
      storage.value.building = payload;
    }
  },
  namespaced: true
};
